import {mariage} from './mariageDef'
import {basic} from 'basic'
import {tree} from '../genealogy'
import React,{useState,useContext} from 'react'
import {listProvinces,showError} from 'tree/treeProvider'
import css from './mariage.module.css'
import ListInput from 'listInput/listInput'
import Text from 'text/text'

function Mariage(props:mariage.props)
{
    const [className,style]=basic.getBasic(props)
    const provinces=useContext(listProvinces)
  //  const seeError=useContext(showError)
   
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        props.onGenChange({...props.value,[e.target.name]: e.target.value})
        // setFormData({
        //   ...formData,
        //   [e.target.name]: e.target.value,
        // });
      };

      function onVilleChange(ville:string)
      {
        props.onGenChange({...props.value,city: ville})
      }


      function datavalidate(e: React.ChangeEvent<HTMLInputElement>)
      {
        const newValue = e.target.value;
        let buf=""
        for(let i=0;i<newValue.length && i<10;i++)
        {
            if(i==4 || i==7)
            {
                buf+='-'
                    
                
            }else if(newValue[i]<'0' || newValue[i]>'9')
                return
            else
                buf+=newValue[i]
        }
        props.onGenChange({...props.value,date: buf})
      }

      const onDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;
        const split=newValue.split("-")
        
        for(let i=0;i<split.length;i++)
        {
            if(split[i].length==0)
                break
            let buf=parseInt(split[i])
            if(isNaN(buf))
                return
            switch(i)
            {
                case 0:
                    if(split[i].length>4)
                        return;
                    if(split[i].length==4 && buf==0)
                        return
                break;
                case 1:
                case 2:
                    if(split[i].length>2)
                        return
                    if(i==1 && buf>12)
                        return    
                   if(i==2 && buf>31)
                        return;
                   if(split[i].length==2 && buf==0)
                        return

                break
            }

        }

        let texte:string=""

        for(let i=0;i<newValue.length;i++)
        {
            if(i>9)
                break
            if(i==4 || i==7)
            {
                if(newValue[i]=='-')
                    texte+=newValue[i]
            }else 
            {
                texte+=newValue[i]
            }


        }

        props.onGenChange({...props.value,date: texte})
        
        


      };

      const {city,province,date}=props.value

      const handleBlur = (event: React.FocusEvent<HTMLDivElement>) => 
      {
        try{
            if(!props.onLoseFocus)
                return
      
            // const {date}=props.value;
            // const split=date.split('-')
            // let year=parseInt(split[0])
            // if(isNaN(year) || year==0)
            //     return
            props.onLoseFocus()

        }catch(error)
        {
            console.log(error)
            debugger
        }
      };

    let erreurDate=""
    if(props.erreur=="date")
        erreurDate="erreurGen"


    return <div className={`${className} ${css.mariage} gmariage`} style={{...style}} onBlur={handleBlur}>
             
                    <Text fr={["Ville du mariage:"]} en={["Wedding city:"]}  className="gmariage gtitre"/>
                    <ListInput 
                           erreur={props.erreur=="ville"}
                         
                           name="city" 
                           value={city} 
                           onChange={handleChange} 
                           onTextChange={onVilleChange}
                          />
              
                
                
              
                    <div className="gmariage gtitre">Province:</div>
                    <select name="province" 
                            value={province} 
                            onChange={handleChange}
                          >
                        {
                            provinces.map(function(value,index){
                                return <option key={index} value={value}>{value}</option>
                            })
                        }
                
                    </select>
            
                    <Text fr={["Date du mariage:"]} en={["Wedding date:"]}  className="gmariage gtitre"/>
                    
                    <input className={erreurDate}
                          
                           name="date" 
                           value={date} 
                           onChange={datavalidate} 
                          />
               
           </div>
}

export default React.memo(Mariage)